var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-logo-pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34.286,
    viewBox: "0 0 30 34.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    d: "M98.143,0A2.149,2.149,0,0,0,96,2.143v30a2.149,2.149,0,0,0,2.143,2.143h21.429a2.149,2.149,0,0,0,2.143-2.143V8.571L113.143,0Z",
    transform: "translate(-91.715)",
    fill: "#e2e5e7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    d: "M354.143,8.571h6.429L352,0V6.429A2.149,2.149,0,0,0,354.143,8.571Z",
    transform: "translate(-330.573)",
    fill: "#b0b7bd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M390.429,134.429,384,128h6.429Z",
    transform: "translate(-360.429 -119.427)",
    fill: "#cad1d8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M57.714,251.786a1.075,1.075,0,0,1-1.071,1.071H33.071A1.075,1.075,0,0,1,32,251.786V241.071A1.075,1.075,0,0,1,33.071,240H56.643a1.075,1.075,0,0,1,1.071,1.071Z",
    transform: "translate(-32 -223.929)",
    fill: "#f15642"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162712",
    "data-name": "Group 162712",
    transform: "translate(4.669 19.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M101.744,294.911a.59.59,0,0,1,.582-.591H104.3a2.142,2.142,0,0,1,0,4.284h-1.43v1.131a.538.538,0,0,1-.549.59.577.577,0,0,1-.582-.59Zm1.13.487v2.134h1.43a1.068,1.068,0,0,0,0-2.134Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M188.415,301.4a.536.536,0,0,1-.591-.53V296a.583.583,0,0,1,.591-.531h1.962c3.915,0,3.829,5.928.077,5.928Zm.54-4.883v3.838h1.422c2.313,0,2.416-3.838,0-3.838Z",
    transform: "translate(-182.06 -295.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M288.257,296.571v1.362h2.185a.663.663,0,0,1,.617.608.6.6,0,0,1-.617.514h-2.185v1.8a.508.508,0,0,1-.513.53.544.544,0,0,1-.608-.53v-4.866a.541.541,0,0,1,.608-.531h3.008a.534.534,0,0,1,.6.531.592.592,0,0,1-.6.583h-2.494Z",
    transform: "translate(-274.721 -295.38)",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M116.357,417.071H96v1.071h20.357a1.075,1.075,0,0,0,1.071-1.071V416A1.075,1.075,0,0,1,116.357,417.071Z",
    transform: "translate(-91.715 -388.144)",
    fill: "#cad1d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.67b550e0a3240e35b236c1ed817998b2.svg";
export { ForwardRef as ReactComponent };